export default "__VITE_ASSET__BaUtkItc__"